<div class="flex flex-col items-start justify-center">
	<div class="flex gap-3 items-center">
		<h1>
			{{getMainValue()}}

		</h1>
		<span class="text-gray-600">{{coverage()?.pricingMode}}</span>
	</div>
	<h4>
		{{getValue()}}
	</h4>

</div>